export { default } from './CrossSiteRedirect';
export * from './CrossSiteRedirect';
